import cn from 'classnames'
import React from 'react'
import { AuctionDetails } from './AuctionDetails'
import { Alert } from '@mui/material'

export const AssetButtonWrapper = ({ buttons, warning, auctionDetails }) => {
    return (
        <div
            className={cn(
                'border dark:!bg-paper bg-white rounded-md shadow-xl',
                'dark:!border-paperl border-zinc-200 p-5 ml-0 lg:ml-4 mt-4',
                { 'grid grid-cols-1 lg:grid-cols-2': auctionDetails },
            )}
        >
            <div>{buttons}</div>

            {warning ? <Alert severity={'warning'}>{warning}</Alert> : ''}
            {auctionDetails ? (
                <AuctionDetails auctionDetails={auctionDetails} />
            ) : (
                ''
            )}
        </div>
    )
}
